module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-8.96213d1e.svg";